export const MAX_DISPLAY_DECIMAL_PLACES = 20;

export type DecimalDisplayCapResult = {
  displayValue: string;
  isDecimalOverflowing: boolean;
};

export function hasReachedDisplayDecimalLimit(value: string): boolean {
  const decimalIndex = value.indexOf('.');

  if (decimalIndex === -1) {
    return false;
  }

  return value.slice(decimalIndex + 1).length >= MAX_DISPLAY_DECIMAL_PLACES;
}

export function limitDisplayDecimalPlaces(value: string): DecimalDisplayCapResult {
  const decimalIndex = value.indexOf('.');

  if (decimalIndex === -1) {
    return { displayValue: value, isDecimalOverflowing: false };
  }

  const integerPart = value.slice(0, decimalIndex);
  const decimalPart = value.slice(decimalIndex + 1);

  if (decimalPart.length <= MAX_DISPLAY_DECIMAL_PLACES) {
    return { displayValue: value, isDecimalOverflowing: false };
  }

  return {
    displayValue: `${integerPart}.${decimalPart.slice(0, MAX_DISPLAY_DECIMAL_PLACES)}…`,
    isDecimalOverflowing: true,
  };
}
